import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=b08cfbb2&"
import script from "./FilterTag.vue?vue&type=script&lang=js&"
export * from "./FilterTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/boban/boban.adamovic.net/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08cfbb2')) {
      api.createRecord('b08cfbb2', component.options)
    } else {
      api.reload('b08cfbb2', component.options)
    }
    module.hot.accept("./FilterTag.vue?vue&type=template&id=b08cfbb2&", function () {
      api.rerender('b08cfbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FilterTag.vue"
export default component.exports